import React from "react";
import { Handle, Position, NodeProps } from "reactflow";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface ProcessNodeData {
  label: string;
}

const ProcessNode: React.FC<NodeProps<ProcessNodeData>> = ({
  data,
  isConnectable,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: "#36276F",
        color: "#ffffff",
        borderRadius: 2,
        boxShadow: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: 2,
        width: 220,
        height: 70,
        border: "2px solid #2a1f58",
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        style={{
          background: "#c4b5fd",
          width: 10,
          height: 20,
          borderRadius: 4,
          border: "1px solid #36276F",
        }}
      />
      <Box>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", fontSize: "1rem" }}
        >
          {data.label}
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontSize: "0.75rem", color: "#c4b5fd" }}
        >
          {t("process_group")}
        </Typography>
      </Box>
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        style={{
          background: "#c4b5fd",
          width: 10,
          height: 20,
          borderRadius: 4,
          border: "1px solid #36276F",
        }}
      />
    </Box>
  );
};

export default ProcessNode;
